/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

import {
  createAsyncThunk,
} from "@reduxjs/toolkit";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { showMessage } from "../../../store/BASE/messageSlice";

export const approveComment = createAsyncThunk(
  "comments/approveComment",
  async (comment, { dispatch, getState }) => {
    try {

      const payload = {
        status: "approved",
        approved: true
      }
      // send request to update comment
      const response = await axios.patch(
        `${process.env.REACT_APP_API_SERVICE_URL}/api/comments/${comment.id}/approval`,
        payload
      );
      // get response data
      const data = await response.data;

      data.replies = comment.replies;
      // show success message
      dispatch(showMessage({ message: "Comment Approved" }));
      // return data
      return data;
    } catch (error) {
      // show error message
      dispatch(showMessage({ message: "Comment Not Approved", variant: "error" }));
      // return null
      return null;
    }
  }
);

export const unapproveComment = createAsyncThunk(
  "comments/unapproveComment",
  async (comment, { dispatch, getState }) => {
    try {

      const payload = {
        status: "pending",
        approved: false
      }
      // send request to update comment
      const response = await axios.patch(
        `${process.env.REACT_APP_API_SERVICE_URL}/api/comments/${comment.id}/approval`,
        payload
      );
      // get response data
      const data = await response.data;

      data.replies = comment.replies;
      // show success message
      dispatch(showMessage({ message: "Comment Approval Removed" }));
      // return data
      return data;
    } catch (error) {
      // show error message
      dispatch(showMessage({ message: "Comment Approval Not Removed", variant: "error" }));
      // return null
      return null;
    }
  }
);

export const publishComment = createAsyncThunk(
  "comments/publishComment",
  async (comment, { dispatch, getState }) => {
    try {
      let updatedCycle;

      switch (comment.review_cycle) {
        case "alpha_internal":
          updatedCycle = "alpha";
          break;
        case "beta_internal":
          updatedCycle = "beta";
          break;
        case "final_internal":
          updatedCycle = "final";
          break;
      }


      const payload = {
        review_cycle: updatedCycle,
      }
      // send request to update comment
      const response = await axios.patch(
        `${process.env.REACT_APP_API_SERVICE_URL}/api/comments/${comment.id}/publish`,
        payload
      );
      // get response data
      const data = await response.data;

      data.replies = comment.replies;
      // show success message
      dispatch(showMessage({ message: "Comment Published" }));
      // return data
      return data;
    } catch (error) {
      // show error message
      dispatch(showMessage({ message: "Comment Not Published", variant: "error" }));
      // return null
      return null;
    }
  }
);

export const unpublishComment = createAsyncThunk(
  "comments/unpublishComment",
  async (comment, { dispatch, getState }) => {
    try {
      let updatedCycle;

      switch (comment.review_cycle) {
        case "alpha":
          updatedCycle = "alpha_internal";
          break;
        case "beta":
          updatedCycle = "beta_internal";
          break;
        case "final":
          updatedCycle = "final_internal";
          break;
      }


      const payload = {
        review_cycle: updatedCycle,
      }
      // send request to update comment
      const response = await axios.patch(
        `${process.env.REACT_APP_API_SERVICE_URL}/api/comments/${comment.id}/publish`,
        payload
      );
      // get response data
      const data = await response.data;

      data.replies = comment.replies;
      // show success message
      dispatch(showMessage({ message: "Comment Unpublished" }));
      // return data
      return data;
    } catch (error) {
      // show error message
      dispatch(showMessage({ message: "Comment Not Unpublished", variant: "error" }));
      // return null
      return null;
    }
  }
);

export const getLessonComments = createAsyncThunk(
  "lessons/getLessonComments",
  async (id, { dispatch, getState }) => {
    try {
      // send request to get lesson comments
      const response = await axios.get(
        `${process.env.REACT_APP_API_SERVICE_URL}/api/lessons/${id}/comments`
      );
      // get response data
      const data = await response.data;
      // return data
      return data;
    } catch (error) {
      // show error message
      dispatch(showMessage({ message: "Lesson Comments Not Found", variant: "error" }));
      // return null
      return null;
    }
  }
);